import axios from "../axios"; // твой базовый axios уже подключён

// === Получить список всех диалогов ===
export const getConversations = async (token) => {
  const response = await axios.get("/api/chat/conversations/", {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

// === Получить конкретный диалог ===
export const getConversation = async (id, token) => {
  const response = await axios.get(`/api/chat/conversations/${id}/`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

// === Получить сообщения внутри диалога ===
export const getMessages = async (conversationId, token) => {
  const response = await axios.get(`/api/chat/conversations/${conversationId}/messages/`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

// === Отправить новое сообщение ===
export const sendMessage = async (
  conversationId,
  text,
  token,
  clientTempId = null,
  replyToId = null
) => {
  const payload = {
    text,
  };

  if (clientTempId) {
    payload.client_temp_id = clientTempId;
  }

  if (replyToId) {
    payload.reply_to_id = replyToId;
  }

  const response = await axios.post(
    `/api/chat/conversations/${conversationId}/messages/`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
};

// === Создать (или получить существующий) диалог между пользователями ===
export const startConversation = async (ad_id, target_profile_id, token) => {
  const response = await axios.post(
    "/api/chat/start/",
    { ad_id, target_profile_id },
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
  return response.data;
};

export const getUnreadChatCount = async (token) => {
  const response = await axios.get("/api/chat/unread-count/", {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

export const markConversationRead = async (conversationId, token) => {
  const response = await axios.post(
    `/api/chat/conversations/${conversationId}/mark-read/`,
    {},
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
  return response.data;
};

export const uploadChatAttachments = async (
  conversationId,
  files,
  token,
  clientTempId = null,
  text = "",
  replyToId = null
) => {
  const formData = new FormData();
  const fileList = Array.isArray(files) ? files : [files];

  fileList.forEach((file) => {
    formData.append("files", file);
  });

  if (text) {
    formData.append("text", text);
  }

  if (clientTempId) {
    formData.append("client_temp_id", clientTempId);
  }

  if (replyToId) {
    formData.append("reply_to_id", replyToId);
  }

  const response = await axios.post(
    `/api/chat/conversations/${conversationId}/attachments/`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
};

export const deleteChatMessage = async (messageId, token) => {
  const response = await axios.post(
    `/api/chat/messages/${messageId}/delete/`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
};